import { useEffect, useState } from "react";

type IconProps = {
  className?: string;
  fill?: string;
};

const CreditCardIcon = ({ className, fill }: IconProps) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <path
        opacity="0.2"
        d="M3 12.1064H29L29.0007 23.9999C29.0007 24.2651 28.8954 24.5195 28.7078 24.707C28.5203 24.8946 28.2659 24.9999 28.0007 24.9999H4.00073C3.73552 24.9999 3.48116 24.8946 3.29363 24.707C3.10609 24.5195 3.00073 24.2651 3.00073 23.9999L3 12.1064Z"
        fill="#2E2E2E"
      />
      <path
        d="M28 7H4C3.44772 7 3 7.44772 3 8V24C3 24.5523 3.44772 25 4 25H28C28.5523 25 29 24.5523 29 24V8C29 7.44772 28.5523 7 28 7Z"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 21H25"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 21H17"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 12.1064H29"
        stroke="#2E2E2E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CreditCardIcon;
